import React from "react";
import Navbar from "../components/Navbar";
import ScrollReveal from "../components/ScrollReveal";
import SEO from "../components/SEO";
import {
  BsLightningCharge,
  BsShieldCheck,
  BsTruck,
  BsGift,
  BsBoxSeam,
  BsHeadset,
  BsCheckCircleFill,
  BsFacebook,
  BsMessenger,
  BsGlobe,
} from "react-icons/bs";
import { SiZalo } from "react-icons/si";

const About = () => {
  return (
    <div className="bg-white dark:bg-slate-950 min-h-screen flex flex-col selection:bg-blue-100 selection:text-blue-900 transition-colors duration-500"
      style={{ 
        zoom: "0.8",
        MozTransform: "scale(0.8)",
        MozTransformOrigin: "top center"
      }}
>
      <SEO
        title="Giới thiệu về TAHA SHOES"
        description="TAHA SHOES - Nâng tầm mỗi bước chân, bứt phá mọi giới hạn. Chuyên cung cấp giày thể thao hiệu suất cao và dịch vụ tận tâm."
      />
      <Navbar />

      <main className="flex-grow pt-16 md:pt-40 pb-12 sm:pb-16 overflow-hidden">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-[1000px] pointer-events-none -z-10 overflow-hidden">
          <div className="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] bg-blue-50 dark:bg-blue-900/20 rounded-full blur-[120px] opacity-60 animate-pulse" />
          <div className="absolute top-[20%] left-[-5%] w-[400px] h-[400px] bg-indigo-50 dark:bg-indigo-900/20 rounded-full blur-[100px] opacity-40" />
          <div
            className="absolute top-0 left-0 w-full h-full opacity-[0.03]"
            style={{
              backgroundImage:
                "radial-gradient(#2563eb 0.5px, transparent 0.5px)",
              backgroundSize: "24px 24px",
            }}
          />
        </div>

        {/* Hero Section */}
        <section className="relative px-4 mb-10 sm:mb-20">
          <div className="max-w-6xl mx-auto">
            <ScrollReveal variants="fade-up">
              <div className="text-center relative">
                <div className="inline-block px-3 py-1 mb-4 sm:mb-8 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-[10px] sm:text-sm font-bold tracking-widest uppercase border border-blue-100 dark:border-blue-800">
                  Về chúng tôi
                </div>
                <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 tracking-tighter">
                  NÂNG TẦM <br className="hidden md:block" />
                  <span
                    style={{
                      display: "block",
                      padding: "0.2em 0 0.1em 0",
                      overflow: "visible",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        display: "block",
                        background:
                          "linear-gradient(to right, #2563eb, #4338ca, #1d4ed8)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        display: "inline",
                        padding: "0.2em 0 0.15em 0",
                      }}
                    >
                      MỖI BƯỚC CHÂN
                    </span>
                  </span>
                </h1>
                <p className="text-sm sm:text-lg md:text-xl font-bold text-gray-800 dark:text-gray-200 mb-6 sm:mb-8 tracking-widest uppercase">
                  Bứt phá mọi giới hạn
                </p>
                <div className="w-20 sm:w-24 h-1 sm:h-1.5 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto rounded-full mb-6 sm:mb-10 shadow-lg shadow-blue-200 dark:shadow-blue-900/40" />
                <p className="max-w-2xl mx-auto text-gray-900 dark:text-gray-100 text-sm sm:text-lg md:text-xl leading-relaxed font-bold transition-colors">
                  Tại{" "}
                  <span className="font-black text-gray-900 dark:text-white border-b-2 sm:border-b-4 border-blue-500/30">
                    TAHA <span className="text-red-600">SHOES</span>
                  </span>
                  , chúng tôi tin rằng một đôi giày tốt không chỉ là phụ kiện,
                  mà là{" "}
                  <span className="text-blue-700 dark:text-blue-400 italic font-black">
                    người bạn đồng hành tin cậy
                  </span>{" "}
                  trên hành trình chinh phục những mục tiêu mới.
                </p>
              </div>
            </ScrollReveal>
          </div>
        </section>

        {/* Brand Philosophy Section */}
        <section className="relative py-10 sm:py-20 overflow-hidden">
          {/* Section Background */}
          <div className="absolute inset-0 bg-gray-900 dark:bg-slate-900 -skew-y-3 origin-right scale-x-110 translate-y-20 -z-10" />

          <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 items-center">
            <div className="relative group">
              <ScrollReveal variants="slide-right" distance={50}>
                <div className="relative z-10 transition-transform duration-500 group-hover:scale-[1.02] flex justify-center">
                  <img
                    src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=1000&auto=format&fit=crop"
                    alt="Taha Shoes Quality"
                    className="max-w-[280px] sm:max-w-full h-auto rounded-3xl md:rounded-[3rem] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.3)] dark:shadow-blue-900/10 border-4 border-white/10 dark:border-white/5 object-cover"
                  />
                  {/* Floating badge */}
                  <div className="absolute -top-3 -right-3 sm:-top-10 sm:-right-10 bg-blue-600 text-white p-3 sm:p-8 rounded-full shadow-2xl animate-bounce-slow flex flex-col items-center justify-center border-2 sm:border-8 border-white dark:border-slate-900 z-20">
                    <span className="text-xl sm:text-4xl font-black italic leading-none">
                      12
                    </span>
                    <span className="text-[8px] sm:text-xs font-bold uppercase tracking-tighter">
                      Tháng BH
                    </span>
                  </div>
                </div>
                <div className="absolute -bottom-5 -left-5 sm:-bottom-10 sm:-left-10 w-32 h-32 sm:w-64 sm:h-64 bg-indigo-600/30 rounded-3xl md:rounded-[3rem] blur-2xl sm:blur-3xl -z-10 animate-pulse" />
              </ScrollReveal>
            </div>

            <div className="space-y-4 sm:space-y-8">
              <ScrollReveal variants="fade-up" delay={0.2}>
                <div className="flex gap-4 sm:gap-6 group">
                  <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-blue-500/10 rounded-2xl sm:rounded-3xl flex items-center justify-center text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-all duration-300 shadow-inner">
                    <BsLightningCharge size={24} className="sm:hidden" />
                    <BsLightningCharge size={32} className="hidden sm:block" />
                  </div>
                  <div>
                    <h4 className="text-white text-lg sm:text-xl font-black mb-1 sm:mb-2 uppercase">
                      Hiệu suất đỉnh cao
                    </h4>
                    <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-lg leading-relaxed font-bold">
                      Chuyên cung cấp các dòng giày tích hợp công nghệ đệm êm ái
                      và chất liệu thoáng khí, giúp bạn tự tin bứt phá trong mọi
                      môi trường luyện tập.
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal variants="fade-up" delay={0.3}>
                <div className="flex gap-4 sm:gap-6 group">
                  <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-indigo-500/10 rounded-2xl sm:rounded-3xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-500 group-hover:text-white transition-all duration-300 shadow-inner">
                    <BsShieldCheck size={24} className="sm:hidden" />
                    <BsShieldCheck size={32} className="hidden sm:block" />
                  </div>
                  <div>
                    <h4 className="text-white text-lg sm:text-xl font-black mb-1 sm:mb-2 uppercase">
                      Bảo vệ & Phong cách
                    </h4>
                    <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-lg leading-relaxed font-bold">
                      Không chỉ bảo vệ đôi chân, mỗi thiết kế còn giúp phong
                      cách thời trang của bạn trở nên trẻ trung, năng động và
                      đầy tính sáng tạo.
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal variants="fade-up" delay={0.4}>
                <div className="p-5 sm:p-8 bg-white/5 backdrop-blur-sm rounded-2xl sm:rounded-[2.5rem] border border-white/10 dark:border-white/5">
                  <p className="text-blue-500 dark:text-blue-400 text-sm sm:text-xl leading-relaxed italic font-medium">
                    "Hãy để{" "}
                    <span className="font-black text-gray-900 dark:text-white border-b-2 sm:border-b-4 border-blue-500/30">
                      TAHA <span className="text-red-600">SHOES</span>
                    </span>{" "}
                    cùng bạn viết tiếp câu chuyện về sự bền bỉ và ý nghĩa của
                    việc không bao giờ bỏ cuộc."
                  </p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        {/* Gift & Packaging Section */}
        <section className="py-12 sm:py-24 px-4 bg-white dark:bg-slate-950 relative">
          <div
            className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-[0.02] pointer-events-none"
            style={{
              backgroundImage: "radial-gradient(#2563eb 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />

          <div className="max-w-6xl mx-auto relative">
            <ScrollReveal variants="fade-up">
              <div className="text-center mb-10 sm:mb-20">
                <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white mb-4 sm:mb-6 tracking-tighter">
                  ĐẶC QUYỀN MUA SẮM
                </h2>
                <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-xl font-bold">
                  Trải nghiệm dịch vụ tuyệt vời nhất tại{" "}
                  <span className="font-black text-gray-900 dark:text-white border-b-2 sm:border-b-4 border-blue-500/30">
                    TAHA <span className="text-red-600">SHOES</span>
                  </span>
                </p>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10">
              <ScrollReveal variants="fade-up" delay={0.1}>
                <div className="relative group h-full">
                  <div className="absolute inset-0 bg-blue-600 rounded-[2rem] sm:rounded-[3rem] blur-2xl opacity-10 dark:opacity-5 group-hover:opacity-20 dark:group-hover:opacity-10 transition-opacity" />
                  <div className="relative bg-gradient-to-br from-blue-600 to-indigo-800 p-6 sm:p-12 rounded-2xl sm:rounded-[3.5rem] text-white flex flex-col items-center text-center h-full border border-blue-400/20 dark:border-blue-400/10 shadow-2xl">
                    <div className="w-16 h-16 sm:w-24 sm:h-24 bg-white/10 rounded-2xl sm:rounded-3xl flex items-center justify-center mb-6 sm:mb-8 backdrop-blur-xl border border-white/20 dark:border-white/10 rotate-3 group-hover:rotate-0 transition-transform duration-500 shadow-xl">
                      <BsGift size={32} className="sm:hidden animate-pulse" />
                      <BsGift
                        size={48}
                        className="hidden sm:block animate-pulse"
                      />
                    </div>
                    <h3 className="text-xl sm:text-3xl font-black mb-4 sm:mb-6 uppercase tracking-tight">
                      Bộ Quà Tặng Đính Kèm
                    </h3>
                    <div className="space-y-3 sm:space-y-4 w-full">
                      <div className="bg-white/10 px-4 sm:px-6 py-3 sm:py-4 rounded-xl sm:rounded-2xl border border-white/10 backdrop-blur-md">
                        <p className="text-sm sm:text-xl font-bold flex items-center justify-center gap-2 sm:gap-3">
                          <span className="text-lg sm:text-2xl">✨</span> 01
                          Chai khử mùi
                        </p>
                      </div>
                      <div className="bg-white/10 px-4 sm:px-6 py-3 sm:py-4 rounded-xl sm:rounded-2xl border border-white/10 backdrop-blur-md">
                        <p className="text-sm sm:text-xl font-bold flex items-center justify-center gap-2 sm:gap-3">
                          <span className="text-lg sm:text-2xl">✨</span> 01 Đôi
                          vớ chuyên dụng
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal variants="fade-up" delay={0.2}>
                <div className="relative group h-full">
                  <div className="absolute inset-0 bg-gray-900 dark:bg-black rounded-[2rem] sm:rounded-[3rem] blur-2xl opacity-5 group-hover:opacity-10 transition-opacity" />
                  <div className="relative bg-gray-900 dark:bg-slate-900 p-6 sm:p-12 rounded-2xl sm:rounded-[3.5rem] text-white flex flex-col items-center text-center h-full border border-gray-700 dark:border-slate-800 shadow-2xl">
                    <div className="w-16 h-16 sm:w-24 sm:h-24 bg-white/5 rounded-2xl sm:rounded-3xl flex items-center justify-center mb-6 sm:mb-8 border border-white/10 dark:border-white/5 -rotate-3 group-hover:rotate-0 transition-transform duration-500 shadow-xl">
                      <BsBoxSeam size={32} className="sm:hidden" />
                      <BsBoxSeam size={48} className="hidden sm:block" />
                    </div>
                    <h3 className="text-xl sm:text-3xl font-black mb-4 sm:mb-6 uppercase tracking-tight">
                      Đóng Gói Chuyên Nghiệp
                    </h3>
                    <p className="text-white text-sm sm:text-xl leading-relaxed font-bold">
                      Mỗi sản phẩm đều được kiểm tra kỹ lưỡng và bảo vệ bằng{" "}
                      <br className="hidden sm:block" />
                      <strong className="text-blue-400 dark:text-blue-300 underline underline-offset-4 sm:underline-offset-8 decoration-2 sm:decoration-4">
                        Bọc chống sốc + Box bảo vệ
                      </strong>{" "}
                      <br className="hidden sm:block" />
                      đảm bảo chất lượng khi đến tay bạn.
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        {/* Commitment Cards */}
        <section className="py-12 sm:py-24 px-4 bg-gray-50 dark:bg-slate-900/50 relative overflow-hidden">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              {[
                {
                  title: "Chất lượng nhất",
                  desc: "Sản phẩm tốt nhất đến tay bạn",
                  color: "from-blue-500 to-indigo-600",
                },
                {
                  title: "Bảo hành 12 tháng",
                  desc: "An tâm sử dụng dài hạn",
                  color: "from-indigo-600 to-blue-700",
                },
                {
                  title: "Free Shipping",
                  desc: "Miễn phí ship toàn quốc",
                  color: "from-blue-700 to-indigo-800",
                },
                {
                  title: "Kiểm tra trước",
                  desc: "Thanh toán khi hài lòng",
                  color: "from-indigo-800 to-gray-900",
                },
              ].map((item, i) => (
                <ScrollReveal key={i} variants="scale-up" delay={i * 0.1}>
                  <div className="relative group">
                    <div
                      className={`absolute inset-0 bg-gradient-to-br ${item.color} rounded-2xl sm:rounded-[2rem] opacity-0 group-hover:opacity-100 dark:group-hover:opacity-80 transition-all duration-500 blur-xl -z-10`}
                    />
                    <div className="bg-white dark:bg-slate-900 p-5 sm:p-8 rounded-2xl sm:rounded-[2rem] text-center shadow-lg dark:shadow-blue-900/10 hover:shadow-2xl transition-all duration-500 h-full border border-gray-100 dark:border-slate-800 flex flex-col items-center group-hover:-translate-y-2">
                      <div
                        className={`w-10 h-10 sm:w-16 sm:h-16 bg-gradient-to-br ${item.color} rounded-xl sm:rounded-2xl flex items-center justify-center text-white mb-4 sm:mb-6 shadow-lg shadow-blue-200`}
                      >
                        <BsCheckCircleFill size={20} className="sm:hidden" />
                        <BsCheckCircleFill
                          size={32}
                          className="hidden sm:block"
                        />
                      </div>
                      <h4 className="font-black text-gray-900 dark:text-white mb-2 sm:mb-3 uppercase text-[10px] sm:text-base tracking-tight">
                        {item.title}
                      </h4>
                      <p className="text-gray-900 dark:text-gray-300 text-[11px] sm:text-sm font-black leading-relaxed transition-colors">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>

        {/* Contact info section */}
        <section className="py-10 sm:py-20 px-4 bg-white dark:bg-slate-950">
          <div className="max-w-6xl mx-auto rounded-3xl md:rounded-[4rem] overflow-hidden shadow-[0_48px_100px_-24px_rgba(0,0,0,0.15)] dark:shadow-blue-900/10 flex flex-col md:flex-row border border-gray-100 dark:border-slate-800">
            <div className="md:w-3/5 bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-900 p-8 sm:p-12 text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />

              <h3 className="text-2xl sm:text-4xl md:text-4xl font-black mb-4 sm:mb-6 leading-tight uppercase tracking-tight">
                Hỗ trợ khách hàng
              </h3>
              <p className="text-sm sm:text-xl text-white dark:text-blue-50 mb-8 sm:mb-12 leading-relaxed font-bold">
                Sự hài lòng của bạn là ưu tiên số 1. TAHA{" "}
                <span className="text-red-500">SHOES</span> sẵn sàng hỗ trợ bạn
                24/7.
              </p>

              <a
                href="https://zalo.me/0765109784"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-4 sm:gap-6 bg-white dark:bg-slate-900 py-2 sm:py-6 px-5 sm:px-8 rounded-2xl sm:rounded-[2.5rem] shadow-2xl hover:scale-105 transition-transform duration-300 group/btn"
              >
                <div className="w-10 h-10 sm:w-16 sm:h-16 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-lg group-hover/btn:rotate-12 transition-transform">
                  <BsHeadset size={28} className="sm:hidden" />
                  <BsHeadset size={36} className="hidden sm:block" />
                </div>
                <div className="text-blue-900 dark:text-white">
                  <p className="text-[8px] sm:text-xs font-black uppercase tracking-[0.2em] mb-1">
                    Hotline Liên Hệ (Zalo)
                  </p>
                  <p className="text-xl sm:text-3xl md:text-4xl font-black">
                    0765.109.784
                  </p>
                </div>
              </a>
            </div>

            <div className="md:w-2/5 bg-gray-50 dark:bg-slate-900/50 p-8 sm:p-12 flex flex-col justify-center">
              <h3 className="text-xl sm:text-2xl font-black text-gray-900 dark:text-white mb-6 sm:mb-10 uppercase tracking-tight relative inline-block">
                Kết nối với chúng tôi
                <span className="absolute -bottom-2 left-0 w-12 h-1 bg-blue-600 rounded-full" />
              </h3>
              <ul className="space-y-6 sm:space-y-6">
                <li className="group cursor-pointer">
                  <a
                    href="https://zalo.me/0765109784"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 sm:gap-6"
                  >
                    <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white dark:bg-slate-800 rounded-xl sm:rounded-2xl flex items-center justify-center text-[#0068ff] shadow-sm border border-gray-100 dark:border-slate-700 group-hover:bg-[#0068ff] group-hover:text-white transition-all duration-300 group-hover:rotate-12 group-hover:scale-110">
                      <SiZalo size={24} className="sm:hidden" />
                      <SiZalo size={28} className="hidden sm:block" />
                    </div>
                    <div>
                      <p className="text-[8px] sm:text-[10px] text-gray-900 dark:text-gray-400 font-bold uppercase tracking-widest mb-1">
                        Zalo Shop
                      </p>
                      <p className="text-gray-900 dark:text-white font-extrabold text-base sm:text-lg group-hover:text-blue-600 transition-colors">
                        TAHA <span className="text-red-600">SHOES</span>
                      </p>
                    </div>
                  </a>
                </li>
                {/* ... existing Facebook and Website items with similar reductions ... */}
                <li className="group cursor-pointer">
                  <a
                    href="https://www.facebook.com/tahashoes.vn"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 sm:gap-6"
                  >
                    <div className="w-12 h-12 sm:w-14 h-14 bg-white dark:bg-slate-800 rounded-xl sm:rounded-2xl flex items-center justify-center text-[#1877f2] shadow-sm border border-gray-100 dark:border-slate-700 group-hover:bg-[#1877f2] group-hover:text-white transition-all duration-300 group-hover:rotate-12 group-hover:scale-110">
                      <BsFacebook size={24} className="sm:hidden" />
                      <BsFacebook size={28} className="hidden sm:block" />
                    </div>
                    <div>
                      <p className="text-[8px] sm:text-[10px] text-gray-900 dark:text-gray-400 font-bold uppercase tracking-widest mb-1">
                        Facebook Fanpage
                      </p>
                      <p className="text-gray-900 dark:text-white font-extrabold text-base sm:text-lg group-hover:text-blue-600 transition-colors">
                        TAHA <span className="text-red-600">SHOES</span>
                      </p>
                    </div>
                  </a>
                </li>
                <li className="flex items-center gap-4 sm:gap-6 group cursor-pointer">
                  <div className="w-12 h-12 sm:w-14 h-14 bg-white dark:bg-slate-800 rounded-xl sm:rounded-2xl flex items-center justify-center text-blue-600 shadow-sm border border-gray-100 dark:border-slate-700 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 group-hover:rotate-12 group-hover:scale-110">
                    <BsGlobe size={24} className="sm:hidden" />
                    <BsGlobe size={28} className="hidden sm:block" />
                  </div>
                  <div>
                    <p className="text-[8px] sm:text-[10px] text-gray-900 dark:text-gray-400 font-bold uppercase tracking-widest mb-1">
                      Official Website
                    </p>
                    <p className="text-blue-600 dark:text-blue-400 font-black text-base sm:text-lg underline decoration-2 underline-offset-4">
                      tahashoes.vn
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
